import { render, staticRenderFns } from "./CommodityCombination.vue?vue&type=template&id=68e0e38e"
import script from "./CommodityCombination.vue?vue&type=script&lang=js"
export * from "./CommodityCombination.vue?vue&type=script&lang=js"
import style0 from "./CommodityCombination.vue?vue&type=style&index=0&id=68e0e38e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports